/* eslint-disable */
import { h, Component } from 'preact';

class IconClose extends Component {
    render() {
        const {width=11, height=9} = this.props;

        return (
            <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <defs>
                    <path id="a1" d="M20 20V0H0v20z"/>
                </defs>
                <g transform="translate(-5 -6)" fill="none" fillRule="evenodd">
                    <mask id="b1" fill="#fff">
                        <use xlinkHref="#a1"/>
                    </mask>
                    <path d="M14.438 6.563l-7.955 7.954" stroke="#626469" strokeLinecap="round" mask="url(#b1)"/>
                    <path d="M14.438 6.563l-7.955 7.954" stroke="#626469" strokeLinecap="round" mask="url(#b1)"
                          transform="matrix(-1 0 0 1 21 0)"/>
                </g>
            </svg>
        );
    }
}

export default IconClose;
